import { toastify } from './SnackBarAlert';
const ERROR_MESSAGES = {
    'ar': "حدث خطأ. يرجى المحاولة مرة أخرى أو الاتصال بنا للمساعدة.",
    'en': "Something went wrong. Please try again or contact us for help."
};
export default (lang, errorMessages) => {
    let messages = [];
    if (errorMessages) {
        if (Array.isArray(errorMessages)) {
            errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.map((e) => messages.push(e.message));
        }
        else {
            messages.push(errorMessages.message);
        }
    }
    toastify({ severity: 'error', title: lang.toLowerCase() === 'en' ? ERROR_MESSAGES.en : ERROR_MESSAGES.ar, description: messages.length > 0 ? messages : '', locale: lang });
};
